import { render, staticRenderFns } from "./PostingPage.vue?vue&type=template&id=401d556a&scoped=true"
import script from "./PostingPage.vue?vue&type=script&lang=js"
export * from "./PostingPage.vue?vue&type=script&lang=js"
import style0 from "./PostingPage.vue?vue&type=style&index=0&id=401d556a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d556a",
  null
  
)

export default component.exports